import { render, staticRenderFns } from "./VueSimpleAccordion.vue?vue&type=template&id=64c1f312"
import script from "./VueSimpleAccordion.vue?vue&type=script&lang=js"
export * from "./VueSimpleAccordion.vue?vue&type=script&lang=js"
import style0 from "./VueSimpleAccordion.vue?vue&type=style&index=0&id=64c1f312&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports